import { render, staticRenderFns } from "./systemName.vue?vue&type=template&id=13356dd2&scoped=true&"
import script from "./systemName.vue?vue&type=script&lang=js&"
export * from "./systemName.vue?vue&type=script&lang=js&"
import style0 from "./systemName.vue?vue&type=style&index=0&id=13356dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13356dd2",
  null
  
)

export default component.exports